import { withGlobal } from "components/global/GlobalWrapper";
import BuildingUnitShow from "./BuildingUnitShow";
import { buildingStructuresReducers } from "components/stores/building_structures/reducers";

export default withGlobal(BuildingUnitShow, { reducers: buildingStructuresReducers });

